import { Flex, Tooltip } from 'antd'
import type { FC } from 'react'
import { FaRegQuestionCircle } from 'react-icons/fa'

type HelpLabelProps = {
  title?: string
  children?: React.ReactNode
}

export const HelpLabel: FC<HelpLabelProps> = ({ title, children }) => {
  return (
    <Tooltip
      title={
        title ? <div className="whitespace-pre-wrap">{title}</div> : undefined
      }
    >
      <Flex align="center">
        {children} <FaRegQuestionCircle className="ml-2" />
      </Flex>
    </Tooltip>
  )
}
